import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import type { JSX } from 'react';
import { teamCostsRouteRef } from './teamCosts/routes';

type WidgetContent = (props?: unknown) => JSX.Element;

const renderBareCard = ({
  Content,
}: {
  Content: WidgetContent;
}): JSX.Element => <Content />;

const teamCostsWidget = HomePageWidgetBlueprint.make({
  name: 'team-costs',
  params: {
    name: 'team-costs',
    components: () =>
      import('./homeWidgets').then(m => ({ Content: m.TeamCostsContent })),
    componentProps: { Renderer: renderBareCard },
  },
});

const teamCostsDetailPage = PageBlueprint.make({
  name: 'team-costs-detail',
  params: {
    path: '/team-costs/:teamSlug',
    title: 'Team Cost',
    routeRef: teamCostsRouteRef,
    noHeader: true,
    loader: () =>
      import('./teamCosts/TeamCostDetailPage').then(m => (
        <m.TeamCostDetailPage />
      )),
  },
});

export const teamCostsModule = createFrontendModule({
  pluginId: 'home',
  extensions: [teamCostsWidget, teamCostsDetailPage],
});
